<template>
    <v-card
        elevation="2"
        outlined
        class="pa-5"
    >
        <v-list-item>
            <v-list-item-avatar
                rounded
                size="40"
                color="rgba(244, 67, 54, .1)"
            >
                <v-icon
                    class="material-icons-outlined"
                    color="#FF0000"
                >
                    notification_important
                </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <span class="title">
                    Recent Emergency Tickets
                </span>
            </v-list-item-content>
        </v-list-item>
        <v-data-table
            :headers="headers"
            :items="recentEmergencyData"
            item-key="code"
        >
            <template
                v-slot:[`item.members`]="{ item }"
            >
                {{ item.members[0] }}
                <v-chip
                    v-if="item.members.length > 1"
                    class="ma-0 pa-1"
                    x-small
                >
                    +{{ item.members.length - 1 }}
                </v-chip>
            </template>
            <template
                v-slot:[`item.ticket`]="{ item }"
            >
                <router-link :to="`/tickets/details?tid=${item.tid}`">
                    {{ item.ticket.toUpperCase() }}
                </router-link>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>

export default {
    props: {
        recentEmergencyData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Members',
                    value: 'members',
                },
                {
                    text: 'Ticket',
                    value: 'ticket',
                },
                {
                    text: 'Date',
                    value: 'ticket_date',
                },
                {
                    text: 'Company',
                    value: 'company',
                },
                {
                    text: 'Work Type',
                    value: 'work_type',
                }
            ],
        };
    },
};

export function formatRecentEmergencyTicketsData(data) {
    function overdueInfo(o) {
        if (o.TS_stage === 'CT') {
            return 'CLOSED';
        }
        if (o.duedate) {
            var d = Date.parse(o.duedate),
                now = new Date();
            var diff = d - now;
            var hr = 1 + Math.floor(diff / 3600000);
            if (d <= now) {
                return 'Overdue';
            }
            return `<${hr}Hrs`;
        }
        return '?Unk';
    }

    var days_of_week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function formatDate(dt) {
        var d = new Date(dt);
        // get day of the week
        var day = days_of_week[d.getDay()];
        return day + ', ' + d.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
    }

    // use a temporary object with keys as the ticket number and values for each column in the table row
    const temp = {};

    data.forEach(dataRow => {
        const tableTicketRow = temp[dataRow.tid];
        if (tableTicketRow) {
            tableTicketRow.members.push(dataRow.TR_member_code);
        } else {
            temp[dataRow.tid] = {
                tid: dataRow.tid,
                members: [ dataRow.TR_member_code ],
                ticket: dataRow.ticket,
                due: overdueInfo(dataRow),
                received: formatDate(Date.parse(dataRow.received)),
                ticket_date: formatDate(Date.parse(dataRow.ticket_date)),
                company: dataRow.company,
                donefor: dataRow.donefor,
                doneby: dataRow.doneby,
                work_type: dataRow.work_type,
            };
        }
    });

    // since each property in the temp object has all the columns in its values, we only need to return the values
    return Object.values(temp);
}

</script>
<style scoped>
.title {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.0015em;
    color: #35383F;
}
</style>
